<template>
  <div id="contenedor-eliminar-obras-licitacion">
    <v-card>
        <v-card-title class="secondary--text">
          Eliminar Obra
        </v-card-title>
        <v-card-text>
          <template v-if="checkLicitacionFallos">
            <span class="secondary--text">
              No se puede eliminar la obra porque la licitación tiene un fallo registrado.
            </span>
          </template>
          <template v-else>
            <span class="secondary--text">
              ¿Está seguro que desea eliminar esta obra de la licitación?
            </span>
            <p class="font-weight-bold mt-2" v-if="obraAEliminar">
              {{ obraAEliminar.obra.clave }}
            </p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="eliminarObraLicitacion"
            :disabled="checkLicitacionFallos"
            :loading="eliminandoObra"
            tipo="formAceptar"
            label="Eliminar">
          </custom-button>
        </v-card-actions>
      </v-card>
  </div>
</template>

<script>
import LICITACION from '@/graphql/querys/administracion/licitaciones/licitacion.gql';
import REMOVER_LICITACION_OBRA from '@/graphql/mutations/administracion/licitaciones/obras/removerLicitacionObra.gql';
import LICITACION_FALLO from '@/graphql/querys/administracion/licitaciones/fallo/licitacionFallo.gql';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarObrasLicitacion',
  props: {
    obraAEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  apollo: {
    licitacionFallo: {
      query: LICITACION_FALLO,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
  data() {
    return {
      eliminandoObra: false,
    };
  },
  methods: {
    async eliminarObraLicitacion() {
      this.eliminandoObra = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_LICITACION_OBRA,
        variables: {
          id: this.obraAEliminar.id,
        },
        update: (store) => {
          const query = {
            query: LICITACION,
            variables: {
              id: this.$route.params.idLicitacion,
            },
          };
          const data = store.readQuery(query);
          if (data && data.licitacion && data.licitacion.obras) {
            const index = data.licitacion.obras
              .findIndex((obra) => obra.id === this.obraAEliminar.id);
            if (index !== -1) {
              data.licitacion.obras.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          }
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.eliminandoObra = false;
      this.mixEsCargando();
      this.cerrar();
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    checkLicitacionFallos() {
      if (!this.licitacionFallo || this.licitacionFallo.length === 0) return false;
      return true;
    },
  },
  mounted() {
    this.$apollo.queries.licitacionFallo.refetch();
  },
};
</script>

<style lang="scss" scoped>

</style>
